export const posts = state => state.blog.posts;